import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { NocApproverListModel } from '../model/NocApproverListModel';
import { NocApproverDetailModel } from '../model/NocApproverDetailModel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';
import { ProApproverDetailModel } from '../model/ProApproverDetailModel';

@Injectable({
  providedIn: 'root'
})
export class NocApproverService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchNocApproverList(page: number, size: number, filterText: string, nocStatus: string) {
    return this.httpClient.get<Page<NocApproverListModel>>(ApiUrls.nocApproverList + 
      `?page=${page}&size=${size}&filterText=${filterText}&nocStatus=${nocStatus}`);
  }

  fetchNocApproverDetail(mortKey: number) {
    return this.httpClient.get<NocApproverDetailModel>(ApiUrls.nocApproverDetail.replace('{mortKey}', mortKey.toString()));
  }

  fetchEsignCertificate(mortKey: number) {
    return this.httpClient.get<{status: string, errorMessage: string, data: string | ArrayBuffer}>
    (ApiUrls.fetchEsignReceiptNoc.replace('{mortKey}', mortKey.toString()));
  }

  cancelNoc(mortKey: number, applicationNo: string) {
    console.log("**Cancel NOC service Called**");
    return this.httpClient.post<{ status: string, errorMessage: string }>(
      ApiUrls.cancelNoc.replace('{mortKey}', mortKey.toString()).replace('{applicationNo}', applicationNo), {});
  }
  
  rejectCancelNocRequest( rejectReason: string, mortKey: number, applicationNo: string) {
    return this.httpClient.post<{ status: string, errorMessage: string }>(
      ApiUrls.rejectCancelNocRequest.replace('{mortKey}', mortKey.toString())
        .replace('{applicationNo}', applicationNo),
        rejectReason);
  }

  submitVerificationDetail(mortKey: number, nocStatus: string,
    rejectReason: string, outwardNo: string) {
    return this.httpClient.post<{status: string, esignKey: number, url: string, errorMessage: string}>(
      ApiUrls.nocApproverDetail.replace('{mortKey}', 
      mortKey.toString()), {
        nocStatus: nocStatus,
        outwardNo: outwardNo,
        rejectReason: rejectReason
    });
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}
